// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ported from ref/sidebar.css — glass sidebar + pill nav items (scoped). */

.pm-cat-sidebar {
  --pm-side-w: 180px;
  --pm-side-radius: 18px;
  --pm-side-bg: #F7F6F5;
  --pm-side-ink: #0f172a;
  --pm-side-muted: #64748b;
  --pm-side-dim: #94a3b8;
  --pm-side-accent: #2563eb;
  --pm-side-glass: rgba(255, 255, 255, 0.72);
  --pm-side-line: rgba(15, 23, 42, 0.08);
  --pm-side-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px rgba(15, 23, 42, 0.05);
  --pm-side-shadow-lg: 0 4px 6px rgba(15, 23, 42, 0.03), 0 16px 40px rgba(15, 23, 42, 0.07);
  --pm-side-grad-ring: linear-gradient(135deg, rgba(99, 102, 241, 0.55), rgba(37, 99, 235, 0.2) 42%, rgba(14, 165, 233, 0.35));
  --pm-side-grad-fill: linear-gradient(135deg, rgba(37, 99, 235, 0.09), rgba(124, 58, 237, 0.05) 55%, rgba(14, 165, 233, 0.06));

  display: flex;
  gap: 12px;
  min-height: 0;
  height: 100%;
  width: 100%;
  max-height: 100%;
  flex: 1 1 0%;
  min-width: 0;
  overflow: hidden;
  letter-spacing: -0.01em;
}

.dark .pm-cat-sidebar {
  --pm-side-bg: #282828;
  --pm-side-ink: #e8eef8;
  --pm-side-muted: #8b9bb3;
  --pm-side-dim: #64748b;
  --pm-side-accent: #3b82f6;
  --pm-side-glass: rgba(17, 24, 39, 0.72);
  --pm-side-line: rgba(148, 163, 184, 0.12);
  --pm-side-shadow: 0 1px 2px rgba(0, 0, 0, 0.3), 0 10px 28px rgba(0, 0, 0, 0.35);
  --pm-side-shadow-lg: 0 8px 40px rgba(0, 0, 0, 0.45);
  --pm-side-grad-ring: linear-gradient(135deg, rgba(129, 140, 248, 0.55), rgba(59, 130, 246, 0.2) 42%, rgba(34, 211, 238, 0.3));
  --pm-side-grad-fill: linear-gradient(135deg, rgba(59, 130, 246, 0.14), rgba(124, 58, 237, 0.08) 55%, rgba(34, 211, 238, 0.08));
}

.pm-cat-sidebar--bordered {
  padding: 12px;
  background: var(--pm-side-bg);
}

/* Unconstrained: grow with content; host/document scrolls */
.pm-cat-sidebar--auto {
  height: auto;
  max-height: none;
  flex: none;
  min-height: 28rem;
  overflow: visible;
  align-items: flex-start;
}

.pm-cat-sidebar--auto .pm-cat-sidebar__nav,
.pm-cat-sidebar--auto .pm-cat-sidebar__stage {
  min-height: 28rem;
  height: auto;
  max-height: none;
}

/* Glass sidebar panel */
.pm-cat-sidebar__nav {
  display: flex;
  flex-direction: column;
  width: var(--pm-side-w);
  flex-shrink: 0;
  min-height: 0;
  height: 100%;
  overflow: hidden;
  border-radius: var(--pm-side-radius);
  background: var(--pm-side-glass);
  border: 1px solid var(--pm-side-line);
  backdrop-filter: blur(20px) saturate(140%);
  -webkit-backdrop-filter: blur(20px) saturate(140%);
  box-shadow: var(--pm-side-shadow);
}

.pm-cat-sidebar__scroll {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 6px 10px 12px;
  scrollbar-width: thin;
  overscroll-behavior-y: contain;
}

/* Allow the nav wheel to chain to the host at either edge. */
.pm-cat-sidebar--auto .pm-cat-sidebar__scroll {
  overscroll-behavior-y: auto;
}

.pm-cat-sidebar__section {
  margin-bottom: 4px;
}

.pm-cat-sidebar__sec {
  position: sticky;
  top: 0;
  z-index: 10;
  margin: 14px 0 6px;
  padding: 4px 10px;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--pm-side-dim);
  background: color-mix(in srgb, var(--pm-side-glass) 88%, transparent);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.pm-cat-sidebar__section:first-child .pm-cat-sidebar__sec {
  margin-top: 4px;
}

/* Pill nav items */
.pm-cat-sidebar__item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 11px;
  width: 100%;
  padding: 7px 12px;
  border-radius: 999px;
  text-align: left;
  color: var(--pm-side-muted);
  border: 1px solid transparent;
  background: none;
  cursor: pointer;
  isolation: isolate;
  font: inherit;
  font-size: 0.92rem;
  font-weight: 500;
  line-height: 1.3;
  transition: color 0.15s, background 0.15s, box-shadow 0.15s;
}

.pm-cat-sidebar__item::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  padding: 1px;
  background: transparent;
  pointer-events: none;
  z-index: -1;
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  transition: background 0.18s, opacity 0.18s;
}

.pm-cat-sidebar__item:hover {
  color: var(--pm-side-ink);
  background: var(--pm-side-grad-fill);
}

.pm-cat-sidebar__item:hover::before {
  background: var(--pm-side-grad-ring);
  opacity: 0.75;
}

.pm-cat-sidebar__item[aria-current="true"] {
  color: var(--pm-side-accent);
  background: var(--pm-side-grad-fill);
  box-shadow: 0 4px 16px rgba(37, 99, 235, 0.08);
}

.pm-cat-sidebar__item[aria-current="true"]::before {
  background: var(--pm-side-grad-ring);
  opacity: 1;
}

.pm-cat-sidebar__label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pm-cat-sidebar__empty {
  padding: 1.5rem 0.75rem;
  text-align: center;
  font-size: 0.8125rem;
  color: var(--pm-side-muted);
}

.pm-cat-sidebar__more {
  padding: 0.5rem;
  text-align: center;
}

/* Detail / stage pane — scrolls independently; nav stays put */
.pm-cat-sidebar__stage {
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  height: 100%;
  overflow: hidden;
  border-radius: var(--pm-side-radius);
  background: var(--pm-side-glass);
  backdrop-filter: blur(18px) saturate(140%);
  -webkit-backdrop-filter: blur(18px) saturate(140%);
}

.pm-cat-sidebar__stage-scroll {
  flex: 1 1 0%;
  min-height: 0;
  min-width: 0;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Nested page/post roots fill the stage and scroll internally */
.pm-cat-sidebar__stage-scroll > * {
  flex: 1 1 0%;
  min-height: 0;
  min-width: 0;
  height: 100%;
  max-height: 100%;
}

.pm-cat-sidebar--bordered .pm-cat-sidebar__stage {
  border: 1px solid var(--pm-side-line);
  box-shadow: var(--pm-side-shadow-lg);
}

/* Auto: pin feed nav while the document scrolls; stage grows with content */
.pm-cat-sidebar--auto .pm-cat-sidebar__nav {
  position: sticky;
  top: 4.5rem;
  align-self: flex-start;
  height: auto;
  max-height: calc(100svh - 5rem);
  overflow: hidden;
}

.pm-cat-sidebar--auto .pm-cat-sidebar__stage,
.pm-cat-sidebar--auto .pm-cat-sidebar__stage-scroll {
  height: auto;
  max-height: none;
  overflow: visible;
  display: block;
  flex: 1 1 auto;
  min-height: 0;
}

.pm-cat-sidebar--auto .pm-cat-sidebar__stage-scroll > * {
  height: auto !important;
  max-height: none !important;
  flex: none !important;
  min-height: 0;
  overflow: visible !important;
}

@media (prefers-reduced-motion: reduce) {
  .pm-cat-sidebar__item,
  .pm-cat-sidebar__item::before {
    transition: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CategorySidebarLayout.css"],"names":[],"mappings":"AAAA,2EAA2E;;AAE3E;EACE,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,yBAAyB;EACzB,0CAA0C;EAC1C,sCAAsC;EACtC,qFAAqF;EACrF,yFAAyF;EACzF,4HAA4H;EAC5H,6HAA6H;;EAE7H,aAAa;EACb,SAAS;EACT,aAAa;EACb,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,yBAAyB;EACzB,uCAAuC;EACvC,yCAAyC;EACzC,+EAA+E;EAC/E,mDAAmD;EACnD,6HAA6H;EAC7H,8HAA8H;AAChI;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA,4DAA4D;AAC5D;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,gCAAgC;EAChC,qCAAqC;EACrC,0CAA0C;EAC1C,kDAAkD;EAClD,iCAAiC;AACnC;;AAEA;EACE,OAAO;EACP,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA,6DAA6D;AAC7D;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,qEAAqE;EACrE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,2DAA2D;AAC7D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,WAAW;EACX,8EAA8E;EAC9E,sEAAsE;EACtE,2BAA2B;EAC3B,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,gCAAgC;EAChC,0CAA0C;EAC1C,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,gEAAgE;AAChE;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA,4EAA4E;AAC5E;EACE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;EACrB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE;;IAEE,2BAA2B;EAC7B;AACF","sourcesContent":["/* Ported from ref/sidebar.css — glass sidebar + pill nav items (scoped). */\r\n\r\n.pm-cat-sidebar {\r\n  --pm-side-w: 180px;\r\n  --pm-side-radius: 18px;\r\n  --pm-side-bg: #F7F6F5;\r\n  --pm-side-ink: #0f172a;\r\n  --pm-side-muted: #64748b;\r\n  --pm-side-dim: #94a3b8;\r\n  --pm-side-accent: #2563eb;\r\n  --pm-side-glass: rgba(255, 255, 255, 0.72);\r\n  --pm-side-line: rgba(15, 23, 42, 0.08);\r\n  --pm-side-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px rgba(15, 23, 42, 0.05);\r\n  --pm-side-shadow-lg: 0 4px 6px rgba(15, 23, 42, 0.03), 0 16px 40px rgba(15, 23, 42, 0.07);\r\n  --pm-side-grad-ring: linear-gradient(135deg, rgba(99, 102, 241, 0.55), rgba(37, 99, 235, 0.2) 42%, rgba(14, 165, 233, 0.35));\r\n  --pm-side-grad-fill: linear-gradient(135deg, rgba(37, 99, 235, 0.09), rgba(124, 58, 237, 0.05) 55%, rgba(14, 165, 233, 0.06));\r\n\r\n  display: flex;\r\n  gap: 12px;\r\n  min-height: 0;\r\n  height: 100%;\r\n  width: 100%;\r\n  max-height: 100%;\r\n  flex: 1 1 0%;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n  letter-spacing: -0.01em;\r\n}\r\n\r\n.dark .pm-cat-sidebar {\r\n  --pm-side-bg: #282828;\r\n  --pm-side-ink: #e8eef8;\r\n  --pm-side-muted: #8b9bb3;\r\n  --pm-side-dim: #64748b;\r\n  --pm-side-accent: #3b82f6;\r\n  --pm-side-glass: rgba(17, 24, 39, 0.72);\r\n  --pm-side-line: rgba(148, 163, 184, 0.12);\r\n  --pm-side-shadow: 0 1px 2px rgba(0, 0, 0, 0.3), 0 10px 28px rgba(0, 0, 0, 0.35);\r\n  --pm-side-shadow-lg: 0 8px 40px rgba(0, 0, 0, 0.45);\r\n  --pm-side-grad-ring: linear-gradient(135deg, rgba(129, 140, 248, 0.55), rgba(59, 130, 246, 0.2) 42%, rgba(34, 211, 238, 0.3));\r\n  --pm-side-grad-fill: linear-gradient(135deg, rgba(59, 130, 246, 0.14), rgba(124, 58, 237, 0.08) 55%, rgba(34, 211, 238, 0.08));\r\n}\r\n\r\n.pm-cat-sidebar--bordered {\r\n  padding: 12px;\r\n  background: var(--pm-side-bg);\r\n}\r\n\r\n/* Unconstrained: grow with content; host/document scrolls */\r\n.pm-cat-sidebar--auto {\r\n  height: auto;\r\n  max-height: none;\r\n  flex: none;\r\n  min-height: 28rem;\r\n  overflow: visible;\r\n  align-items: flex-start;\r\n}\r\n\r\n.pm-cat-sidebar--auto .pm-cat-sidebar__nav,\r\n.pm-cat-sidebar--auto .pm-cat-sidebar__stage {\r\n  min-height: 28rem;\r\n  height: auto;\r\n  max-height: none;\r\n}\r\n\r\n/* Glass sidebar panel */\r\n.pm-cat-sidebar__nav {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: var(--pm-side-w);\r\n  flex-shrink: 0;\r\n  min-height: 0;\r\n  height: 100%;\r\n  overflow: hidden;\r\n  border-radius: var(--pm-side-radius);\r\n  background: var(--pm-side-glass);\r\n  border: 1px solid var(--pm-side-line);\r\n  backdrop-filter: blur(20px) saturate(140%);\r\n  -webkit-backdrop-filter: blur(20px) saturate(140%);\r\n  box-shadow: var(--pm-side-shadow);\r\n}\r\n\r\n.pm-cat-sidebar__scroll {\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow: auto;\r\n  padding: 6px 10px 12px;\r\n  scrollbar-width: thin;\r\n  overscroll-behavior-y: contain;\r\n}\r\n\r\n/* Allow the nav wheel to chain to the host at either edge. */\r\n.pm-cat-sidebar--auto .pm-cat-sidebar__scroll {\r\n  overscroll-behavior-y: auto;\r\n}\r\n\r\n.pm-cat-sidebar__section {\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.pm-cat-sidebar__sec {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 10;\r\n  margin: 14px 0 6px;\r\n  padding: 4px 10px;\r\n  font-size: 0.7rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.12em;\r\n  text-transform: uppercase;\r\n  color: var(--pm-side-dim);\r\n  background: color-mix(in srgb, var(--pm-side-glass) 88%, transparent);\r\n  backdrop-filter: blur(12px);\r\n  -webkit-backdrop-filter: blur(12px);\r\n}\r\n\r\n.pm-cat-sidebar__section:first-child .pm-cat-sidebar__sec {\r\n  margin-top: 4px;\r\n}\r\n\r\n/* Pill nav items */\r\n.pm-cat-sidebar__item {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 11px;\r\n  width: 100%;\r\n  padding: 7px 12px;\r\n  border-radius: 999px;\r\n  text-align: left;\r\n  color: var(--pm-side-muted);\r\n  border: 1px solid transparent;\r\n  background: none;\r\n  cursor: pointer;\r\n  isolation: isolate;\r\n  font: inherit;\r\n  font-size: 0.92rem;\r\n  font-weight: 500;\r\n  line-height: 1.3;\r\n  transition: color 0.15s, background 0.15s, box-shadow 0.15s;\r\n}\r\n\r\n.pm-cat-sidebar__item::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  inset: 0;\r\n  border-radius: inherit;\r\n  padding: 1px;\r\n  background: transparent;\r\n  pointer-events: none;\r\n  z-index: -1;\r\n  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\r\n  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\r\n  -webkit-mask-composite: xor;\r\n  mask-composite: exclude;\r\n  transition: background 0.18s, opacity 0.18s;\r\n}\r\n\r\n.pm-cat-sidebar__item:hover {\r\n  color: var(--pm-side-ink);\r\n  background: var(--pm-side-grad-fill);\r\n}\r\n\r\n.pm-cat-sidebar__item:hover::before {\r\n  background: var(--pm-side-grad-ring);\r\n  opacity: 0.75;\r\n}\r\n\r\n.pm-cat-sidebar__item[aria-current=\"true\"] {\r\n  color: var(--pm-side-accent);\r\n  background: var(--pm-side-grad-fill);\r\n  box-shadow: 0 4px 16px rgba(37, 99, 235, 0.08);\r\n}\r\n\r\n.pm-cat-sidebar__item[aria-current=\"true\"]::before {\r\n  background: var(--pm-side-grad-ring);\r\n  opacity: 1;\r\n}\r\n\r\n.pm-cat-sidebar__label {\r\n  min-width: 0;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.pm-cat-sidebar__empty {\r\n  padding: 1.5rem 0.75rem;\r\n  text-align: center;\r\n  font-size: 0.8125rem;\r\n  color: var(--pm-side-muted);\r\n}\r\n\r\n.pm-cat-sidebar__more {\r\n  padding: 0.5rem;\r\n  text-align: center;\r\n}\r\n\r\n/* Detail / stage pane — scrolls independently; nav stays put */\r\n.pm-cat-sidebar__stage {\r\n  position: relative;\r\n  display: flex;\r\n  flex: 1;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n  min-height: 0;\r\n  height: 100%;\r\n  overflow: hidden;\r\n  border-radius: var(--pm-side-radius);\r\n  background: var(--pm-side-glass);\r\n  backdrop-filter: blur(18px) saturate(140%);\r\n  -webkit-backdrop-filter: blur(18px) saturate(140%);\r\n}\r\n\r\n.pm-cat-sidebar__stage-scroll {\r\n  flex: 1 1 0%;\r\n  min-height: 0;\r\n  min-width: 0;\r\n  height: 100%;\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n/* Nested page/post roots fill the stage and scroll internally */\r\n.pm-cat-sidebar__stage-scroll > * {\r\n  flex: 1 1 0%;\r\n  min-height: 0;\r\n  min-width: 0;\r\n  height: 100%;\r\n  max-height: 100%;\r\n}\r\n\r\n.pm-cat-sidebar--bordered .pm-cat-sidebar__stage {\r\n  border: 1px solid var(--pm-side-line);\r\n  box-shadow: var(--pm-side-shadow-lg);\r\n}\r\n\r\n/* Auto: pin feed nav while the document scrolls; stage grows with content */\r\n.pm-cat-sidebar--auto .pm-cat-sidebar__nav {\r\n  position: sticky;\r\n  top: 4.5rem;\r\n  align-self: flex-start;\r\n  height: auto;\r\n  max-height: calc(100svh - 5rem);\r\n  overflow: hidden;\r\n}\r\n\r\n.pm-cat-sidebar--auto .pm-cat-sidebar__stage,\r\n.pm-cat-sidebar--auto .pm-cat-sidebar__stage-scroll {\r\n  height: auto;\r\n  max-height: none;\r\n  overflow: visible;\r\n  display: block;\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n}\r\n\r\n.pm-cat-sidebar--auto .pm-cat-sidebar__stage-scroll > * {\r\n  height: auto !important;\r\n  max-height: none !important;\r\n  flex: none !important;\r\n  min-height: 0;\r\n  overflow: visible !important;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .pm-cat-sidebar__item,\r\n  .pm-cat-sidebar__item::before {\r\n    transition: none !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
